import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { DatePickerComponent } from "../DatePicker/DatePickerComponent";
import { PromptDialog } from "../Dialog/PromptDialog";
import { PageTransition } from "../Spinner/PageTransition";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import Card from '@material-ui/core/Card';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import * as ReactTooltip from 'react-tooltip'
import * as moment from "moment";
import ContractCard from "../../Partials/Contract/ContractCard";

class ContractListing extends Component {
  protected selectedContract: ContractInterface;
  private unitId: number = 0;
  private personId: number = 0;
  protected contractsPaginatorPath: string;
  protected timerId: any;

  public state = {
    endDate: null,
    endDateNotValid: false,
    expirationDate: this.selectedContract && this.selectedContract.expirationDate ? this.selectedContract.expirationDate : null,
    isDialogOpen: false,
    isRenewDialogOpen: false,
    isExpirationDialogOpen: false,
    isDoYouWantToDeleteContractDialogOpen: false,
    isRemoveButtonDisabled: true,
    contractToDelete: null,
    anchorEl: null,
    isCheckFirstDateDialogOpen: false,
    checkFirstDate: null,
    eventsForContracts: [],
    isSaving: false,
    intervalTickForRemoveButton: 5,
    labelForRemoveButton: this.trans("button-remove"),
    contractIdForDetailsPresentation: null,
  };

  public componentWillMount() {
    this.setState({
      eventsForContracts: this.props.eventsForContracts,
      contractIdForDetailsPresentation: this.props.contracts
      .filter((contract: ContractInterface) => !contract?.removed)
      .sort((contract1: ContractInterface, contract2: ContractInterface) => {
        if (contract1.firstDate < contract2.firstDate) {
          return 1;
        }
    
        if (contract1.firstDate > contract2.firstDate) {
          return -1;
        }
    
        return  0;
      })?.[0]?.id,
    })
  }

  public componentWillReceiveProps(nextProps) {
    this.setState({
      eventsForContracts: nextProps.eventsForContracts
    });
  }
 
  constructor(public props) {
    super(props);

    if (typeof this.props.unitId !== "undefined") {
      this.unitId = this.props.unitId;
      this.contractsPaginatorPath = `UnitContracts_${this.unitId}`;
    }

    if (typeof this.props.personId !== "undefined") {
      this.personId = this.props.personId;
      this.contractsPaginatorPath = `PersonContracts_${this.personId}`;
    }

    this.openRenewDialog = this.openRenewDialog.bind(this);
    this.closeRenewDialog = this.closeRenewDialog.bind(this);
    this.openSetExpirationDateDialog = this.openSetExpirationDateDialog.bind(this);
    this.closeSetExpirationDateDialog = this.closeSetExpirationDateDialog.bind(this);
  }

  public openEndDialog = () => {
    this.setState({
      isDialogOpen: true,
      anchorEl: null
    });
  }

  public closeEndDialog = () => {
    this.setState({
      isDialogOpen: false,
      endDate: null
    });
  }

  public openRenewDialog() {
    this.setState({
      isRenewDialogOpen: true,
      anchorEl: null
    });
  }

  public closeRenewDialog() {
    this.setState({
      isRenewDialogOpen: false
    });
  }

  public openSetExpirationDateDialog() {
    this.setState({
      isExpirationDialogOpen: true
    });
  }

  public closeSetExpirationDateDialog() {
    this.setState({
      isExpirationDialogOpen: false
    });
  }

  public selectDate(momentDate: any, identifier: string): any {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      isCheckFirstDateDialogOpen: moment(date).date() === 1,
      [identifier]: date
    });

    this.setModifiedData();
  }

  public setDroppedStatus(contract: ContractInterface) {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTRACT_UPDATE_START,
        payload: {
          contract: {
            id: contract.id,
            status: this.props.app.contractStatuses["DROPPED"],
            firstDate: contract.firstDate,
            lastDate: contract.lastDate,
            finalRentalPeriodDate: contract.finalRentalPeriodDate,
            expirationDate: contract.expirationDate,
            payChargesUntilDate: contract.payChargesUntilDate,
            note: contract.note,
            unitId: contract.unitId
          },
          unit: contract.unit,
          person: contract.person,
          company: contract?.company,
          chargeTemplates: contract.chargeTemplates,
          additionalFields: []
        },
        onSuccess: () => {
          this.setState({
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public saveEndDate = (contract: ContractInterface) => {
    let date = this.state.endDate

    this.setState({
      endDateNotValid: false
    }, () => {
      if (!(date instanceof Date && !isNaN(Number(date)))) {
        return this.setState({endDateNotValid: true})
      }

      this.saving(() => {
        return this.props.dispatch({
          type: Constants.GLOBAL_CONTRACT_END_START,
          payload: {
            contractId: contract.id,
            endDate: date
          },
          onSuccess: () => {
            this.setState({
              isSaving: false,
              endDate: date
            }, () => {
              this.props.dispatch({
                type: Constants.SNACKBAR_ADD_MESSAGE,
                payload: {
                  message: this.state.endDate > new Date() ?
                  `${this.trans("dialog/postprocess-endcontract-ending-info-1", {endDate: this.formatter.formatDate(this.state.endDate)})} ${this.trans("dialog/postprocess-endcontract-ending-info-2")}` :
                  `${this.trans("dialog/postprocess-endcontract-ended-info-1", {endDate: this.formatter.formatDate(this.state.endDate)})}`,
                  type: "info"
                }
              });
            });
          },
          onError: () => {
            this.setState({
              isSaving: false
            });
          }
        });
      });

      this.closeEndDialog();
    });
  }

  public clearEndDate = (contract: ContractInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_END_START,
        payload: {
          contractId: contract.id,
          endDate: null
        },
        onSuccess: () => {
          this.setState({
            isSaving: false,
            endDate: null
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public saveExpirationDate(contract: ContractInterface) {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_EXPIRATION_START,
        payload: {
          contractId: contract.id,
          expirationDate: this.state.expirationDate
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          this.setState({
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  protected openMenu = (event: any, contract: ContractInterface): void => {
    this.selectedContract = contract;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public getContracts = () => {
    return this.props.contracts
    .filter((contract: ContractInterface) => contract.removed === false)
    .sort((contract1: ContractInterface, contract2: ContractInterface) => {
      if (contract1.firstDate < contract2.firstDate) {
        return 1;
      }

      if (contract1.firstDate > contract2.firstDate) {
        return -1;
      }

      return  0;
    })
    .map((contract: ContractInterface, index: number) => {
      const occupants = contract.occupants.map(occupant => {
        return `${occupant.person.firstName} ${occupant.person.lastName}`
      })

      const monthlyChargeTemplatesAmount: number = [...contract.chargeTemplates]
      .filter((chargeTemplate: ChargeTemplateInterface) => chargeTemplate?.repeatPeriod?.id === PeriodContainer.pickIdFromLabel("monthly"))
      .map((chargeTemplate: ChargeTemplateInterface) => chargeTemplate.amount)
      .reduce((a, b) => a + b, 0);

      const contractAlerts =  !!this.state.eventsForContracts &&
                              this.state.eventsForContracts
                                .filter(event => event.contractId === contract.id &&
                                  event.removed === false && event.hidden === false &&
                                  (event.eventTypeId === 16 ||
                                    event.eventTypeId === 21 ||
                                    event.eventTypeId === 33));

      let contractAlertsTitles = contractAlerts.map(alert => alert.subject);

      contractAlertsTitles = !contract.paidStatus ?
                             [...new Set([...contractAlertsTitles, this.trans("unpaid-charges")])] :
                             [... new Set([...contractAlertsTitles])];

      return (
        <TableRow
          hover
          key={index}
          className={`clickable-entity`}
          onClick={() => {
            this.redirect(`/app/contract/update/${contract.id}/${this.personId}/${this.unitId}`);
          }}
        >
          <TableCell style={{width: "24px", paddingLeft: "10px", paddingRight: "5px"}}>
            <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
              <div
                className="icon icon-ic-contract"
              >
              </div>
            </div>
          </TableCell>
          <TableCell style={{color: "rgba(0, 0, 0, 0.54)"}}>{contract.id}</TableCell>
          {this.props.unitId && occupants && occupants.length === 0 && (
            <TableCell style={{width: "25%"}}>{contract?.tenantDisplayName}</TableCell>
          )}
          {this.props.unitId && occupants && occupants.length > 0 && (
            <TableCell style={{width: "25%", paddingTop: "5px", paddingBottom: "5px", height: "auto"}}>
              <div style={{display: "flex", flexDirection: "column"}}>
                <div>{contract?.tenantDisplayName}</div>
                <div style={{color: "gray", fontSize: "12px"}}>
                  {
                    occupants.join(", ")
                  }
                </div>
              </div>
            </TableCell>
          )}
          {!this.props.unitId && (
            <TableCell style={{width: "25%"}}>{contract.unit.displayName}</TableCell>
          )}
          <TableCell style={{width: "15%"}}>
            {
              !!monthlyChargeTemplatesAmount ?
                <span>{this.formatter.formatNumber(monthlyChargeTemplatesAmount, contract.chargeTemplates[0] && contract.chargeTemplates[0].currency)}</span> :
                <span>{this.formatter.formatNumber(monthlyChargeTemplatesAmount, this.props.app.settings.user.currency)}</span>
            }
          </TableCell>
          <TableCell style={{width: "15%", minWidth: "100px"}}>{this.formatter.formatDate(contract.firstDate)}</TableCell>
          <TableCell style={{width: "15%", minWidth: "100px"}}>{this.formatter.formatDate(contract.endDate)}</TableCell>
          <TableCell style={{width: "15%"}}>{this.trans(contract.contractStatus)}</TableCell>
          <TableCell style={{width: "5%"}}>
            {((contractAlerts && contractAlerts.length > 0) || !contract.paidStatus) && (
              <div>
                <span data-tip={contractAlertsTitles.join(', ')}>
                  <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "6px"}}>
                    <div
                      className="icon icon-ic-info red"
                      onClick={e => {
                        e.stopPropagation();
                        this.redirect(`/app/contract/update/${contract.id}/${this.personId}/${this.unitId}?financeTab=true`);
                      }}
                    >
                    </div>
                  </div>
                </span>
                <ReactTooltip place="bottom" />
              </div>)
            }
          </TableCell>
          <TableCell
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div>
              <IconButton
                onClick={e => this.openMenu(e, contract)}
              >
                <div className="icon icon-ic-more-vert"></div>
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl) && this.selectedContract && this.selectedContract.id === contract.id}
                onClose={this.closeMenu}
                disableAutoFocusItem={true}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left"
                }}
                getContentAnchorEl={null}
              >
                <MenuItem
                  onClick={() => {
                    this.redirect(`/app/contract/update/${this.selectedContract.id}/${this.personId}/${this.unitId}`);
                  }}
                >
                  <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                </MenuItem>
                {!!this.selectedContract && (this.selectedContract.isSigned || this.selectedContract.isExpiring) && (
                  <MenuItem
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                                                action: "renew",
                                                entityName: "contract",
                                                entity: this.selectedContract
                                              })) {
                        this.openIsBusyPopup();
                        this.setState({anchorEl: null});
                      } else {
                        this.openRenewDialog();
                      }
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-extend aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-renew")}</ListItemText>
                  </MenuItem>
                )}
                {!!this.selectedContract && !this.selectedContract.isConcept && !this.selectedContract.isDropped && !this.selectedContract.isEnding && !this.selectedContract.endDate && (
                  <MenuItem
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                                              action: "end",
                                              entityName: "contract",
                                              entity: this.selectedContract
                                            })) {
                        this.openIsBusyPopup();
                        this.setState({anchorEl: null});
                      } else {
                        this.openEndDialog();
                        this.setState({ endDate: this.selectedContract.endDate });
                      }
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-stop"></div></ListItemIcon>
                    <ListItemText>{this.trans("set-end-date")}</ListItemText>
                  </MenuItem>
                )}
                {!!this.selectedContract && !!this.selectedContract.endDate && (
                  <MenuItem
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                                              action: "end",
                                              entityName: "contract",
                                              entity: this.selectedContract
                                            })) {
                        this.openIsBusyPopup();
                        this.setState({anchorEl: null});
                      } else {
                        this.setState({anchorEl: null}, () => this.clearEndDate(this.selectedContract));
                      }
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-stop"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-clear-end-date")}</ListItemText>
                  </MenuItem>
                )}
                <MenuItem
                  className="delete-action"
                  onClick={() => {
                    if (this.checkProcessIsBusy({
                                          action: "remove",
                                          entityName: "contract",
                                          entity: this.selectedContract
                                        })) {
                      this.openIsBusyPopup();
                      this.setState({anchorEl: null});
                    } else {
                      this.openDeleteContractDialog(this.selectedContract);
                    }
                  }}
                >
                  <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                </MenuItem>
              </Menu>
            </div>
          </TableCell>
        </TableRow>
      );
    });
  }

  public doIntervalTickForRemoveButton = () => {
    clearInterval(this.timerId);

    if (this.state.intervalTickForRemoveButton === 1) {
      this.setState({
        isRemoveButtonDisabled: false,
        labelForRemoveButton: this.trans("button-remove")
      })
    } else {
      this.setState({
        intervalTickForRemoveButton: this.state.intervalTickForRemoveButton - 1,
        labelForRemoveButton: this.trans("button-remove") + ` (${this.state.intervalTickForRemoveButton - 1}s)`
      }, () => {
        this.timerId = setInterval(() => {
          this.doIntervalTickForRemoveButton()
        }, 1000);
      });
    }
  }

  public openDeleteContractDialog = (contract: ContractInterface): any => {
    this.setState({
      contractToDelete: contract,
      anchorEl: null,
      intervalTickForRemoveButton: 5,
      isRemoveButtonDisabled: true,
      labelForRemoveButton: this.trans("button-remove") + ` (${this.state.intervalTickForRemoveButton}s)`
    }, () => this.setState({
          isDoYouWantToDeleteContractDialogOpen: true,
        }, () => {
          this.timerId = setInterval(() => {
            this.doIntervalTickForRemoveButton()
          }, 1000);
        })
    )
  }

  public closeDeleteContractDialog = (): any => {
    clearInterval(this.timerId);
    this.setState({
      isDoYouWantToDeleteContractDialogOpen: false,
      isRemoveButtonDisabled: true,
      intervalTickForRemoveButton: 5
    });
  }

  public deleteContract(contract: ContractInterface): any {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_DELETE_START,
        payload: {
          contract: contract
        },
        onSuccess: () => {
          this.closeDeleteContractDialog();

          this.setState({
            isSaving: false
          });

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.state.contractToDelete && (this.state.contractToDelete.isConcept || this.state.contractToDelete.isDropped) ?
                this.trans("dialog/postprocess-removenotsignedcontract") :
                this.trans("dialog/postprocess-removesignedcontract"),
              type: "info"
            }
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          })
        },
      });
    });
  }

  public checkUnitDefaultChargeTemplates = () => {
    return this.goToCreateNewContractPage();
  }

  public goToCreateNewContractPage = () => {
    this.redirect(`/app/contract/create/${this.personId}/${this.unitId}`);
  }

  public goToCreateDefaultChargeTemplatesPage = () => {
    this.props.dispatch({
      type: Constants.PERSON_ID_FOR_CREATING_CONTRACT,
      payload: {
        personIdForCreatingContract: this.personId
      }
    });

    this.redirect(`/app/unit/${this.unitId}/default-charge-templates`);
  }

  public render(): JSX.Element {
    let minExpirationDate = null;

    if (this.selectedContract) {
      minExpirationDate = this.selectedContract.firstDate < new Date() ? new Date() : this.selectedContract.firstDate;
    }
    return (
      <div className="component">
        <Card className="card no-padding">
          <div>
            {
              this.props.contracts
                .filter((contract: ContractInterface) => !contract?.removed)
                .sort((contract1: ContractInterface, contract2: ContractInterface) => {
                  if (contract1.firstDate < contract2.firstDate) {
                    return 1;
                  }
            
                  if (contract1.firstDate > contract2.firstDate) {
                    return -1;
                  }
            
                  return  0;
                })
                .map((contract: ContractInterface) => {
                  return (
                    <div className="component-wrapper no-margins has-margin-bottom">
                      <div className="component">
                        <ContractCard
                          {...this.props}
                          key={`contract-${contract?.id}`}  
                          contract={contract} 
                          contractIdForDetailsPresentation={this.state.contractIdForDetailsPresentation}
                          changeContractIdForDetailsPresentation={id => this.setState({contractIdForDetailsPresentation: id})}
                        />
                      </div>
                    </div>
                  );
                })
            }
          </div>
        </Card>

        <PromptDialog
          {...this.props}
          title={this.trans("end-contract-modal-title")}
          content={(
            <div>
              <p>{this.trans("dialog/preprocess-endcontract-info1")}</p>
              <div style={{width: "50%"}}>
                <DatePickerComponent
                  {...this.props}
                  label={this.selectedContract && this.selectedContract.endDate ?
                    this.trans("end-date") : this.trans("label-click-set-the-end-date")}
                  initialDate={this.state.endDate ? this.state.endDate : null}
                  onChange={date => this.selectDate(date, "endDate")}
                  clearButton={true}
                  minDate={this.selectedContract && this.selectedContract.firstDate}
                  minDatePlusDays={1}
                  minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                  error={this.state.endDateNotValid && this.trans("be_ajv_not_validated")}
                />
              </div>
              <p>{this.trans("dialog/preprocess-endcontract-info2")}</p>
              <p>{this.selectedContract && !!this.selectedContract.isActive && this.trans("dialog/preprocess-endcontract-info3")}</p>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("end-contract")}
          positiveButtonStyle={{backgroundColor:"red"}}
          openLeavePrompt={this.state.isDialogOpen}
          prioritizeClosing={true}
          onDiscard={this.closeEndDialog}
          onSave={() => this.saveEndDate(this.selectedContract)}
          hideCross={true}
          additionalBtns={this.selectedContract && !!this.selectedContract.isActive && (
            [<Button
              key="dialog-additional-btn"
              color="primary"
              onClick={() => this.redirect(`/app/contract/extend/${this.selectedContract.id}`)}
            >
              {this.trans("renew-contract")}
            </Button>]
          )}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-date")}
          content={(
            <div>
              <p>{this.trans("dialog/preprocess-info/checkfirstdate")}</p>
              <p>{this.trans("dialog/preprocess-info2/checkfirstdate")}</p>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-continue")}
          openLeavePrompt={this.state.isCheckFirstDateDialogOpen}
          prioritizeClosing={true}
          onDiscard={() => this.setState({isCheckFirstDateDialogOpen: false})}
          onSave={() => { this.setState({isCheckFirstDateDialogOpen: false}); this.selectDate(this.state.checkFirstDate, "checkFirstDate") }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("renew-contract")}
          content={(
            <div>
              <p>{this.trans("dialog/renewcontract-info1")}</p>
              <p>{this.trans("dialog/renewcontract-info2")}</p>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("renew-contract")}
          openLeavePrompt={this.state.isRenewDialogOpen}
          prioritizeClosing={true}
          onDiscard={this.closeRenewDialog}
          onSave={() => { this.closeRenewDialog(); this.redirect(`/app/contract/extend/${this.selectedContract.id}`); }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("continue-contract")}
          content={(
            <div>
              <p>{this.trans("you-are-about-to-continue-contract")}</p>
              <div style={{width: "30%"}}>
                <DatePickerComponent
                  {...this.props}
                  className="scroll-to-expirationDate"
                  label={this.selectedContract && this.selectedContract.expirationDate ?
                    this.trans("expiration-date") : this.trans("label-expiration-date-not-set")}
                  initialDate={this.state.expirationDate}
                  onChange={date => this.selectDate(date, "expirationDate")}
                  minDate={minExpirationDate}
                  minDatePlusDays={0}
                  clearButton={true}
                  error={this.getErrorFor("expirationDate")}
                />
              </div>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("label-continue")}
          openLeavePrompt={this.state.isExpirationDialogOpen}
          prioritizeClosing={true}
          onDiscard={this.closeSetExpirationDateDialog}
          onSave={() => { this.closeSetExpirationDateDialog(); this.saveExpirationDate(this.selectedContract); }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-delete-contract")}
          content={
            this.state.contractToDelete && (this.state.contractToDelete.isConcept || this.state.contractToDelete.isDropped) ?
              <div>
                <p>{this.trans("dialog/preprocess-removenotsignedcontract", {
                      tenant: this.state.contractToDelete && this.state.contractToDelete.person ? this.state.contractToDelete.person.displayName : ""
                    })}
                </p>
              </div>
              :
              this.state.contractToDelete && this.state.contractToDelete.previousContractId ?
                <div>
                  <p>{this.trans("dialog/preprocess-removesignedcontract-baseverison")}</p>
                  <p>{this.trans("dialog/preprocess-removesignedcontract-renewedverison")}</p>
                </div>
                :
                <div>
                  <p>{this.trans("dialog/preprocess-removesignedcontract-baseverison")}</p>
                </div>
          }
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.state.contractToDelete && (this.state.contractToDelete.isConcept || this.state.contractToDelete.isDropped) ? this.trans("button-remove") : this.state.labelForRemoveButton}
          positiveButtonDisabled={this.state.contractToDelete && (this.state.contractToDelete.isConcept || this.state.contractToDelete.isDropped) ? false : this.state.isRemoveButtonDisabled}
          openLeavePrompt={this.state.isDoYouWantToDeleteContractDialogOpen}
          prioritizeClosing={true}
          positiveButtonStyle={{backgroundColor:"red"}}
          onDiscard={this.closeDeleteContractDialog}
          onSave={() => this.deleteContract(this.state.contractToDelete)}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

export { ContractListing };
